import { render, staticRenderFns } from "./rwpasangan.vue?vue&type=template&id=112e8b45"
import script from "./rwpasangan.vue?vue&type=script&lang=js"
export * from "./rwpasangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports